import React from "react";
import l from "components/util/l";
import { environmentLabel } from "components/presentation/environments/Environments.lib";

const ManageEnvironmentView = ({
  rows,
  panel,
  editingId,
  isMergeable,
  isSaving,
  onClickPanel,
  onSubmitCreate,
  onClickEdit,
  onClickCancelEdit,
  onSubmitRename,
  onClickDelete,
  onClickMerge
}) =>
  <div className="card">
    <div className="card-body">

      <div className="d-flex align-items-center justify-content-between mb-3">
        <h4 className="mb-0">{l("Configuración%GA120")}</h4>
        <span>
          <button
            type="button"
            className={`btn btn-sm mr-2 ${panel == "add" ? "btn-accent" : "btn-outline-accent"}`}
            title={l("Agregar entorno%EN007")}
            onClick={() => onClickPanel("add")}
          >
            <i className="fas fa-plus"></i>
          </button>
          {isMergeable &&
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              title={l("Publicar cambios a otro entorno%EN023")}
              onClick={onClickMerge}
            >
              <i className="fas fa-code-merge"></i>
            </button>}
        </span>
      </div>

      {
        panel == "add" &&
        <form
          className="d-flex align-items-center border rounded p-3 mb-3"
          onSubmit={(event) => {
            event.preventDefault();
            onSubmitCreate(event.target.elements.environment_name.value);
          }}
        >
          <input
            className="form-control form-control-sm mr-2"
            name="environment_name"
            placeholder={l("Nombre del entorno%EN006")}
            autoFocus
            required
          />
          <button type="submit" className="btn btn-sm btn-accent" disabled={isSaving}>
            {
              isSaving
                ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                : l("Guardar%GA023")
            }
          </button>
        </form>
      }


      {rows.map((row) => (
        <div key={row.id} className="d-flex align-items-center justify-content-between py-3 border-bottom">
          {
            editingId == row.id
              ? <form
                  className="d-flex align-items-center flex-grow-1"
                  onSubmit={(event) => {
                    event.preventDefault();
                    onSubmitRename(row.id, event.target.elements.environment_name.value);
                  }}
                >
                  <input
                    className="form-control form-control-sm mr-2"
                    name="environment_name"
                    defaultValue={row.environmentName || ""}
                    autoFocus
                    required
                  />
                  <button type="submit" className="btn btn-sm btn-accent mr-1" disabled={isSaving}>
                    {l("Guardar%GA023")}
                  </button>
                  <button type="button" className="btn btn-sm btn-light" onClick={onClickCancelEdit}>
                    {l("Cancelar%GA021")}
                  </button>
                </form>
              : <>
                  <span>
                    {environmentLabel(row)}
                    <small>{row.isRoot ? ` (${l("Principal%EN027")})` : ""}</small>
                    {row.isCurrent && <span className="badge badge-soft-secondary ml-2">{l("Actual%PA820")}</span>}
                  </span>
                  {
                    row.isEditable &&
                    <span className="d-flex align-items-center">
                      <button type="button" className="btn btn-sm btn-white mr-1"
                        title={l("Renombrar%EN005")} onClick={() => onClickEdit(row.id)}>
                        <i className="fas fa-pen"></i>
                      </button>
                      <button type="button" className="btn btn-sm btn-white text-danger"
                        title={l("Eliminar%GA001")} disabled={isSaving} onClick={() => onClickDelete(row)}>
                        <i className="fas fa-trash"></i>
                      </button>
                    </span>
                  }
                </>
          }
        </div>
      ))}

    </div>
  </div>

export default ManageEnvironmentView;
